import { useState } from 'react';
import {
  Grid,
  TextField,
  Button,
  Typography,
  Backdrop,
  CircularProgress,
  Stack
} from '@material-ui/core';
import { useRecoilState } from 'recoil';
import Dropzone from '../components/dropzone/Dropzone';
import { useNavigate } from 'react-router';
import { snackbarAtom } from 'src/atoms/snackbar';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import { employeeDeleteRequest } from 'src/services/employee.service';
import axios from 'axios';
import ConfirmationDialogue from 'src/components/ConfirmationDialogue';
import { useMutation } from 'react-query';
import { queryClient } from 'src';
import { convertImage } from 'src/utils/convertImage';
function EmployeeEditRequest({ data }) {
  const navigate = useNavigate();
  const theme = useTheme();
  const match = useMediaQuery(theme.breakpoints.down('lg'));

  /* eslint-disable no-unused-vars */
  const [snackbar, setSnackbar] = useRecoilState(snackbarAtom);
  const [doctorBill, setDoctorBill] = useState(data?.dr_receipt_bill ?? 0);
  const [medicationBill, setMedicationBill] = useState(data?.medications_bill ?? 0);
  const [raysOrAnalysisBill, setRaysOrAnalysisBill] = useState(data?.raysOrAnalysisBill ?? 0);

  const [notes, setNotes] = useState(data?.notes ?? 'NA');
  const [open, setOpen] = useState(false);
  const [reqOwner, setReqOwner] = useState(data?.party_id ?? data?.beneficiary_id);

  const [showConfirmation, setShowConfirmation] = useState(false);

  const [deletedPrescriptions, setDeletedPrescriptions] = useState([]);
  const [deletedReports, setDeletedReports] = useState([]);
  const [deletedMedicalBills, setDeletedMedicalBills] = useState([]);

  const [oldMedicalBills, setOldMedicalBills] = useState(data?.medical_bill ?? []);
  const [oldDoctorPrescription, setOldDoctorPrescription] = useState(data?.dr_prescription ?? []);
  const [oldReports, setOldReports] = useState(data?.analysis_rays_request ?? []);

  const [addedMedicalBills, setAddedMedicalBills] = useState([]);
  const [addedDoctorPrescription, setAddedDoctorPrescription] = useState([]);
  const [addedReports, setAddedReports] = useState([]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setOpen(true);
    const body = {
      notes,
      dr_receipt_bill: doctorBill,
      medications_bill: medicationBill,
      raysOrAnalysisBill: raysOrAnalysisBill,
      deleted_dr_prescription: deletedPrescriptions,
      deleted_analysis_rays_request: deletedReports,
      deleted_medical_bill: deletedMedicalBills
    };
    const formData = new FormData();

    formData.append('data', JSON.stringify(body));

    await Promise.all(
      addedDoctorPrescription
        .map(async (img) => {
          await convertImage({ file: img, formData: formData, key: 'added_dr_prescription' });
        })
        .concat(
          addedReports.map(async (img) => {
            await convertImage({
              file: img,
              formData: formData,
              key: 'added_analysis_rays_request'
            });
          })
        )
        .concat(
          addedMedicalBills.map(async (img) => {
            await convertImage({ file: img, formData: formData, key: 'added_medical_bill' });
          })
        )
    );
    const url = `/employees/requests/${data?.id}`;
    try {
      if (
        oldDoctorPrescription.length +
          addedDoctorPrescription.length -
          deletedPrescriptions.length <
        1
      ) {
        throw new Error('Please add atleast one doctor prescription');
      }
      if (oldMedicalBills.length + addedMedicalBills.length - deletedMedicalBills.length < 1) {
        throw new Error('Please add atleast one medical bill');
      }
      const { status } = await axios({
        url,
        method: 'PATCH',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      if (status !== 200) {
        throw new Error('Something went wrong');
      }
    } catch (err) {
      setSnackbar({ severity: 'error', open: true, message: err.message });
      console.log(err);
    }
    setOpen(false);
  };
  const { mutate: editRequest } = useMutation(handleSubmit, {
    onSettled: () => {
      queryClient.invalidateQueries(['request', data?.id]);
      navigate('../');
    }
  });
  return (
    <div style={{ padding: '12px' }}>
      <Grid
        style={{
          marginTop: '20px',
          marginBottom: '20px',
          overflow: 'hidden',
          borderRadius: '10px',
          padding: '10px',
          boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)'
        }}
      >
        <Typography variant="h4">Doctor Comments</Typography>
        <Typography variant="body1" gutterBottom>
          {data?.dr_comments ?? 'NA'}
        </Typography>
      </Grid>
      <Grid
        style={{
          marginTop: '20px',
          marginBottom: '20px',
          overflow: 'hidden',
          borderRadius: '10px',
          padding: '10px',
          boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)'
        }}
      >
        <Typography variant="h4">Admin Comments</Typography>
        <Typography variant="body1" gutterBottom>
          {data?.admin_comments ?? 'NA'}
        </Typography>
      </Grid>
      <form onSubmit={handleSubmit} style={{ paddingInline: match ? '20px' : '0px' }}>
        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
          <Grid direction="column" alignItems="center" justifyContent="center">
            <Typography variant="h4">Please Wait...</Typography>
            <div style={{ width: '100%', display: 'grid', placeItems: 'center' }}>
              <CircularProgress color="inherit" />
            </div>
          </Grid>
        </Backdrop>
        <Typography variant="h4" style={{ marginBottom: '20px' }}>
          Edit Request
        </Typography>
        <Grid container>
          <Grid item container spacing={3} md={12} xs={12} marginBottom={6}>
            <Grid item container md={4} xs={12}>
              <TextField
                type="number"
                id="outlined-basic"
                label="Doctor or Hospital Bill (EGP)"
                variant="outlined"
                required
                value={doctorBill}
                style={{ width: '100%' }}
                onChange={(e) => {
                  setDoctorBill(Number(e.target.value));
                }}
              />
            </Grid>
            <Grid item container md={4} xs={12}>
              <TextField
                type="number"
                id="outlined-basic"
                label="Medicine Bill (EGP)"
                variant="outlined"
                required
                value={medicationBill}
                style={{ width: '100%' }}
                onChange={(e) => {
                  setMedicationBill(Number(e.target.value));
                }}
              />
            </Grid>
            <Grid item container md={4} xs={12}>
              <TextField
                type="number"
                id="outlined-basic"
                label="Rays or Analysis Bill (EGP)"
                variant="outlined"
                required
                value={raysOrAnalysisBill}
                style={{ width: '100%' }}
                onChange={(e) => {
                  setRaysOrAnalysisBill(Number(e.target.value));
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid style={{ marginBottom: '20px' }}>
          <Typography variant="h5">
            Prescription
            <span>*</span>
          </Typography>
          <Dropzone
            setAddedFiles={setAddedDoctorPrescription}
            addedFiles={addedDoctorPrescription}
            oldFiles={oldDoctorPrescription}
            deletedImages={deletedPrescriptions}
            setDeletedImages={setDeletedPrescriptions}
          />
        </Grid>
        <Grid style={{ marginBottom: '20px' }}>
          <Typography variant="h5">
            Bills <span>*</span>
          </Typography>
          <Dropzone
            setAddedFiles={setAddedMedicalBills}
            addedFiles={addedMedicalBills}
            oldFiles={oldMedicalBills}
            deletedImages={deletedMedicalBills}
            setDeletedImages={setDeletedMedicalBills}
          />
        </Grid>
        <Grid style={{ marginBottom: '20px' }}>
          <Typography variant="h5">Reports</Typography>
          <Dropzone
            setAddedFiles={setAddedReports}
            addedFiles={addedReports}
            oldFiles={oldReports}
            deletedImages={deletedReports}
            setDeletedImages={setDeletedReports}
          />
        </Grid>
        <Grid
          item
          container
          md={12}
          xs={12}
          style={{ display: 'flex', alignItems: 'stretch' }}
          marginBottom={6}
        >
          <Box sx={{ width: '100%' }}>
            <TextField
              id="standard-textarea"
              label="Notes"
              placeholder="Write any additonal information (Eg. health conditions)"
              multiline
              style={{ width: '100%' }}
              variant="standard"
              value={notes}
              onChange={(e) => {
                setNotes(e.target.value);
              }}
            />
          </Box>
        </Grid>
        <Stack justifyContent={'flex-end'} direction={'row'} spacing={2}>
          <Button color="error" variant="contained" onClick={() => setShowConfirmation(true)}>
            Delete Request
          </Button>
          <Button type="submit" variant="contained">
            Save Changes
          </Button>
        </Stack>
      </form>
      <ConfirmationDialogue
        open={showConfirmation}
        setOpen={setShowConfirmation}
        onConfirm={() => employeeDeleteRequest({ id: data?.id })}
        queryId={['request', data?.id]}
        redirectUrl={'/dashboard/requests'}
        loadingMessage={'Your request is being deleted. Please do not close or refresh this page.'}
        confirmationMessage={'Are you sure you want to delete this request?'}
        successMessage={'Request deleted successfully!'}
      />
    </div>
  );
}

export default EmployeeEditRequest;
